import { render, staticRenderFns } from "./Bbyk.vue?vue&type=template&id=8b9b537e&scoped=true"
import script from "./Bbyk.vue?vue&type=script&lang=js"
export * from "./Bbyk.vue?vue&type=script&lang=js"
import style0 from "./Bbyk.vue?vue&type=style&index=0&id=8b9b537e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9b537e",
  null
  
)

export default component.exports